<style lang="scss" scoped>
.instagram-input-form {
  background: #eee;
  padding: 15px 15px 50px;
  margin-bottom: 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.instagram-input-info {
  border: 1px solid #c8d2d6;
  border-radius: 4px;
  background: #fff;
  width: 338px;
  display: inline-block;
  padding: 12px 8px;
  margin: 0 0 15px;
  .instagram-input-author {
    font-size: 12px;
    margin: 0 0 10px;
  }

  img {
    max-width: 100%;
  }
}
.btn-normal {
  margin-top: 5px;
}
.insta-input-preview {
  font-size: 2rem;
}
</style>
<template>
  <div class="instagram-input">
    <div class="instagram-input-form" v-if="isEditing">
      <h2>Instagram</h2>
      <div class="form-group">
        <input
          class="form-control"
          type="text"
          v-model="instagram_url"
          placeholder="instagramのURLを入力してください"
        />
        <p class="small">https://instagram.com/p/:id/ 形式で入力</p>
      </div>
      <div class="form-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div v-else class="insta-input-preview input-preview">
      <h2>
        <a :href="instagram_url" target="_blank">
          {{ instagram_url }}
        </a>
      </h2>
      <img :src="instagram_image_url" />
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  mounted() {
    this.instagram_url = this.value.insta_url;
  },
  components: {
    'footer-menu': footerMenu,
  },
  computed: {
    fetched() {},
    bodyJSON() {
      return {
        value: {
          insta_url: this.instagram_url,
        },
        action: 'insta',
        id: this.id,
      };
    },
    valid() {
      return this.instagram_url.length;
    },
    instagram_image_url() {
      try {
        let url = new URL(this.instagram_url);
        url = `${url.origin}${url.pathname}`;
        url = url.match(/\/$/) ? `${url}media` : `${url}/media`;
        return url;
      } catch (e) {
        return '/images/noimage.png';
      }
    },
  },
  data() {
    return {
      isEditing: false,
      instagram_url: '',
    };
  },
  methods: {
    alertURL() {
      alert('URLが間違っているか、ネットワークエラーが発生しています。');
      return false;
    },
    getInstaId(url) {
      let urls = url.split('/');
      let x = [];
      for (var i = 0; i < urls.length; i++) {
        if (
          urls[i] == 'embed' ||
          urls[i].match(/tagged/) ||
          urls[i].match(/taken-by/) ||
          urls[i] == ''
        ) {
          continue;
        }
        x.push(urls[i]);
      }
      return x[x.length - 1];
    },
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        alert('URLを確認してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>
